"use client";

import React from "react";
import { Plane, Map, Building, Package, Loader, Sparkles } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
const serviceOptions = [{
  id: "aereos",
  label: "Aéreos",
  icon: Plane
}, {
  id: "terrestre",
  label: "Terrestre",
  icon: Map
}, {
  id: "buenos-aires",
  label: "Buenos Aires",
  icon: Building
}, {
  id: "paquetes",
  label: "Paquetes",
  icon: Package
}];
function InquiryFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control,
    resetForm
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in duration-500">
        <div className="size-16 rounded-lg bg-primary/20 flex items-center justify-center mb-4">
          <Sparkles className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-default font-semibold text-foreground">¡Solicitud Recibida!</h3>
        <p className="text-muted-foreground max-w-sm">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-6 rounded-md border-primary/50 hover:bg-primary/10">
          Nueva Consulta
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="service" rules={{
      required: "Por favor selecciona una categoría"
    }} render={({
      field
    }) => <FormItem className="space-y-4">
            <FormLabel className="text-foreground/80 uppercase tracking-wider text-xs font-semibold">Categoría de Servicio</FormLabel>
            <FormControl>
              <RadioGroup onValueChange={field.onChange} defaultValue={field.value} className="grid grid-cols-2 gap-3">
                {serviceOptions.map((option, i) => <div key={option.id} data-index={i}>
                    <RadioGroupItem value={option.id} id={option.id} className="peer sr-only" />
                    <Label htmlFor={option.id} className="flex flex-col items-center justify-center gap-2 rounded-md border border-border/50 bg-background/50 p-4 hover:bg-accent/20 hover:border-primary/50 peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-primary/10 peer-data-[state=checked]:text-primary cursor-pointer transition-all duration-300">
                      <option.icon className="size-6 mb-1 opacity-80" />
                      <span className="font-medium text-sm">{option.label}</span>
                    </Label>
                  </div>)}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="space-y-4 pt-2">
        <FormField control={control} name="fullName" rules={{
        required: "El nombre es obligatorio",
        minLength: {
          value: 2,
          message: "Mínimo 2 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/80">Nombre Completo</FormLabel>
              <FormControl>
                <Input placeholder="Ej. Juan Pérez" className="bg-background/50 border-border/50 focus-visible:border-primary rounded-md" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField control={control} name="email" rules={{
          required: "El correo es obligatorio",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Correo electrónico inválido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground/80">Correo Electrónico</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="tu@email.com" className="bg-background/50 border-border/50 focus-visible:border-primary rounded-md" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="phone" rules={{
          required: "El teléfono es obligatorio",
          minLength: {
            value: 8,
            message: "Mínimo 8 dígitos"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground/80">Teléfono</FormLabel>
                <FormControl>
                  <Input type="tel" placeholder="+1 234 567 890" className="bg-background/50 border-border/50 focus-visible:border-primary rounded-md" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>
      </div>

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm text-center">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full rounded-md h-12 text-base font-semibold tracking-wide mt-4">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Procesando...
          </> : "Solicitar Presupuesto"}
      </Button>
    </Form>;
}
export default function TravelInquiryForm() {
  return <section id="travelinquiryform" className="py-16 md:py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="bg-card rounded-xl border border-primary/30 shadow-2xl overflow-hidden flex flex-col lg:flex-row">
          
          {}
          <div className="lg:w-5/12 p-8 md:p-12 flex flex-col justify-center relative overflow-hidden bg-card">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent pointer-events-none" />
            <div className="relative z-10 space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-2">
                <Sparkles className="size-4" />
                <span>Servicios Exclusivos</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-default font-light leading-tight text-card-foreground">
                ¿Planificando tu <br />
                <span className="font-semibold text-primary">próximo viaje?</span>
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">En Viaje Perfecto, llevamos el mundo hacia ti. Déjanos diseñar la logística perfecta para tu próxima gira, evento o escapada con nuestra atención de primer nivel.</p>
              
              <div className="pt-8 border-t border-border/50 mt-8">
                <p className="text-sm text-muted-foreground uppercase tracking-widest font-semibold mb-4">Asistencia Global</p>
                <div className="flex items-center gap-4 text-card-foreground">
                  <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center border border-primary/20">
                    <Plane className="size-6 text-primary" />
                  </div>
                  <div>
                    <p className="font-medium">Soporte 24/7</p>
                    <p className="text-sm text-muted-foreground">Para todas tus reservas</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:w-7/12 p-8 md:p-12 bg-background/50 backdrop-blur-sm border-l border-border/10">
            <FormProvider formId="travel-inquiry-hero" sectionName="TravelInquiryForm" defaultValues={{
            service: "",
            fullName: "",
            email: "",
            phone: ""
          }} submitText="Solicitar Presupuesto" successMessage="¡Gracias por tu consulta! Nuestro equipo de especialistas se pondrá en contacto contigo a la brevedad para coordinar los detalles de tu viaje.">
              <InquiryFormContent />
            </FormProvider>
          </div>

        </div>
      </div>
    </section>;
}